import { useEffect } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
// import { toast } from 'react-toastify';
import { API_SERVER } from '../config/constant';

// Module-level storage for current account state
// This ensures the interceptor ALWAYS has access to the latest token
let currentAccount = {
    token: null,
    org: null,
    username: null
};

// Helper to decode JWT and check what's inside
const decodeJWT = (token) => {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    } catch (e) {
        console.error('Failed to decode JWT:', e);
        return null;
    }
};

// Export function to update token from anywhere (including reducer if needed)
export const updateCurrentToken = (account) => {
    const newToken = account?.user?.access_token || null;
    
    currentAccount = {
        token: newToken,
        org: account?.user?.org || null,
        username: account?.user?.username || null
    };
    
    // CRITICAL: Decode the JWT to see what org is ACTUALLY in the token
    if (newToken) {
        const decoded = decodeJWT(newToken);
        console.log('🔄 Module-level token updated:');
        console.log('   Token (first 30):', newToken.substring(0, 30) + '...');
        console.log('   User.org from object:', currentAccount.org);
        console.log('   🔍 JWT decoded payload:', decoded);
        console.log('   🔍 Org inside JWT token:', decoded?.org);
        
        if (decoded?.org !== currentAccount.org) {
            console.error('❌ MISMATCH! User.org !== JWT.org');
            console.error('   User object says org:', currentAccount.org);
            console.error('   JWT token says org:', decoded?.org);
            console.error('   THIS IS THE BUG! Backend will use:', decoded?.org);
        } else {
            console.log('✅ Token org matches user org');
        }
    }
};

const axiosServices = axios.create();

axiosServices.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject((error.response && error.response.data) || 'Wrong Services'),
);

export default axiosServices;

// Set up the request interceptor ONCE at module load
// It will always read from currentAccount which gets updated by useEffect
let requestInterceptorId = null;

const setupRequestInterceptor = () => {
    if (requestInterceptorId !== null) {
        axios.interceptors.request.eject(requestInterceptorId);
    }
    
    requestInterceptorId = axios.interceptors.request.use(
        (config) => {
            const token = currentAccount.token;
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
                console.log('📤 Request interceptor - injecting token for:', config.url);
                console.log('   Token (first 30):', token.substring(0, 30) + '...');
                console.log('   Org:', currentAccount.org);
            } else {
                console.warn('⚠️ No token available for request:', config.url);
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
    
    console.log('✅ Request interceptor installed with ID:', requestInterceptorId);
};

// Initialize interceptor on module load
setupRequestInterceptor();

export const InjectAxiosInterceptors = () => {
    const navHistory = useHistory();
    const account = useSelector((state) => state.account);
    
    useEffect(() => {
        axios.defaults.baseURL = API_SERVER;
        axios.defaults.disableClientErrorHandling = true;
        
        // Update the module-level token reference
        updateCurrentToken(account);
        
    }, [account?.user?.access_token, account?.user?.org]);

    addInterceptors(navHistory);

    return null;
};

export const addInterceptors = (history) => {
    axios.interceptors.response.use((response) => response, (error) => Promise.reject(axiosErrorHandling(error, history)));
};

export const axiosErrorHandling = (error, history) => {
    const statusCode = error?.response?.status;
    
    if (statusCode) {
        if (!error?.config?.disableAuthErrorHandling && statusCode === 401) {
        // if (statusCode === 401) {
            console.log('axios statusCode history push', statusCode);
            history.push('/auth/logout');
            // window.location.href = '/auth/logout';

        } else if (statusCode === 403) {
            console.error('Usuário sem permissão!');
        // Handle 4xx errors if error handling enabled
        } else if (!error?.config?.disableClientErrorHandling && statusCode >= 400 && statusCode < 500 && statusCode !== 401) {
            const errorMessages = [];
            const errorDetails = error.response.data?.detail;
            if (errorDetails) {
                if (Array.isArray(errorDetails)) {
                    errorDetails.forEach((errorDetail) => {
                        errorMessages.push(`${errorDetail.loc[1]}: ${errorDetail.msg}`);
                    });
                } else if (typeof errorDetails === 'string') {
                    errorMessages.push(error.response.data.detail);
                }
            }
            if (errorMessages.length === 0) {
                if (error?.response?.statusText) {
                    errorMessages.push(error?.response?.statusText);
                } else {
                    errorMessages.push('Algo deu errado!');
                }
            }
            errorMessages.forEach((errorMessage) => console.error(errorMessage));
            // Handle Server errors
        } else if (statusCode >= 500) {
            console.error('Internal server error!');
        }
    // Handle server errors if there is no response
    } else if (error?.message) {
        console.error(error.message);
    // Default error message
    } else {
        console.error('Algo deu errado!');
    }

    return error;
};
